import React from 'react';
import { Row } from 'simple-flexbox';
import logo from 'images/panel/microzync.png';

function LogoComponent() {
    return (
        <Row key={"logoheader"}> 
            {/*<span className={classes.title}>eMonedero</span>*/}
            <img key={"logoheaderImg"} src={logo} className="sidebar-logo" alt='sidebar logo'/>
        </Row>
    );
}

export default LogoComponent;
